// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import LoadingIcon from '../../components/LoadingIcon';
import Button from '../../components/Button';
import CompletionStatusTag from '../../components/CompletionStatusTag';
import HandsOnCompletionStatusTag from '../../components/HandsOnCompletionStatusTag';
import EmptyIcon from '../../assets/images/home-page-empty.svg';
import IconDrop from '../../assets/images/icon-drop.svg';
import ReturnIcon from '../../assets/images/exam-return-icon.svg';
import examReviewFileIcon from '../../assets/images/exam-review-file-icon.svg';
import VisibleIcon from '../../assets/images/visible.svg';
import EditIcon from '../../assets/images/edit-icon.svg';
import QuestionsAllCorrectIcon from '../../assets/images/course-content-completed-pic.svg';
import LevelMeter from '../../components/LevelMeter';
import Tab from '../../components/HomeTabs';
import TabsStyle from '../../components/HomeTabs/styles'
import { Link } from 'react-router-dom';
import { rgba } from 'polished';
import ErrorPage from '../ErrorPage';

const otherS = {
  Banner: styled.div`
    margin-top: 24px;
    border-bottom: 1px solid #DEDEDE;
  `,
  BannerContainer: styled.div`
    width: 100%;
    max-width: 1116px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  `,
  HistoryContainer: styled.div`
    width: 100%;
    max-width: 1116px;
    margin: 24px auto;
  `,
  Title: styled.div`
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 24px;
    color: #434343;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  TitleContainer: styled.div`
  `,
  Tab: styled(Tab)`
    align-self: flex-end;

    ${TabsStyle.Tab} {
      min-width: 140px;
    }
  `,
  CourseContainer: styled.div`
    width: 100%;
    max-width: 1149px;
    margin: 0 auto;
    display: flex;
    flex-grow: 1;
    padding: 24px 0;
  `,
  ListWrapper: styled.div`
    display: grid;
    grid-template-columns: auto auto auto auto;
    gap: 36px;
  `,
  // History Table Comps
  HistoryTableWrapper: styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: minmax(91px,auto) 1fr auto auto auto fit-content(14ch) auto;
    max-width: 1116px;
    align-items: center;
  `,
  LevelMeter: styled(LevelMeter)`
    justify-content: flex-end;

    div {
      font-size: 16px;
      flex-shrink: 0;
    }
  `,
  TableCellLink: styled(Link)`
    display: flex;
    align-items: center;
    padding: 10px 12px;
    background-color: #fff;
    transition: background-color 0.3s;

    &:hover {
      background-color: #ffd163;
    }
  `,
  TableHeadingText: styled.span`
    position: relative;
  `,
  TableSortIcon: styled.img.attrs({ src: IconDrop, alt: 'icon-drop' }) <{ isAscending?: boolean }>`
    position: absolute;
    top: 50%;
    left: calc(100% + 6px);
    transition: transform .5s;
    transform: translateY(-50%) rotate(${props => props.isAscending ? 0 : 180}deg);
  `,
  TableCell: styled.div<{ isCenter?: boolean }>`
    font-size: 16px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #313131;
    ${props => props.isCenter ? `
      display: flex;
      justify-content: center;
      text-align: center;
    ` : null}

    /* border: 1px solid black; */

    &:nth-child(7n + 1) {
      /* background-color: #777; */
    }

    &:nth-child(7n + 2) {
      padding-left: 15px;
      padding-right: 18px;
      /* background-color: #888; */
    }

    &:nth-child(7n + 3) {
      padding-left: 18px;
      padding-right: 18px;
      /* background-color: #999; */
    }

    &:nth-child(7n + 4) {
      text-align: right;
      padding-left: 16px;
      padding-right: 25px;
      /* background-color: #aaa; */
    }

    &:nth-child(7n + 5) {
      padding-left: 22px;
      padding-right: 22px;
      /* background-color: #ccc; */
    }

    &:nth-child(7n + 6) {

    }

    &:nth-child(7n) {
      padding-left: 19px;
      padding-right: 19px;
      /* background-color: #ddd; */
    }
  `,
  LoadingWrapper: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
  `,
  LoadingAnimation: styled(LoadingIcon).attrs({ size: 20 })``,
  NoDataWrapper: styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
  `,
  EmptyHomeIcon: styled.img.attrs({ src: EmptyIcon, alt: 'empty-icon' })``,
  EmptyHomeText: styled.div`
    font-size: 18px;
    color: #313131;
    margin-bottom: 24px;
    text-align: center;
  `,
  EmptyHomeLink: styled(Button)`
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    min-width: 142px;
    padding: 0 14px;
  `,
  CompletionStatusTag: styled(CompletionStatusTag)``,
  HandsOnCompletionStatusTag: styled(HandsOnCompletionStatusTag)``,
  VisibleIcon: styled.img.attrs({ src: VisibleIcon })`
    cursor: pointer;
  `,
  // Exam History Table
  HandsOnHistoryTableWrapper: styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: minmax(91px,300px) auto auto auto auto auto;
    max-width: 1116px;
    align-items: center;
  `,
  HistoryTableExamLink: styled.div<{ isCenter?: boolean }>`
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 10px 12px;
    color: #313131;
    transition: background-color 0.3s;

    &:hover {
      background-color: #ffd163;
      cursor: pointer;
    }
  `,
  HistoryTableCell: styled.div<{ isCenter?: boolean }>`
    font-size: 16px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #313131;
    ${props => props.isCenter ? `
      display: flex;
      justify-content: center;
      text-align: center;
    ` : null}

    &:nth-child(6n + 1) {
      padding-left: 15px;
    }

    &:nth-child(6n + 2) {
      padding-left: 15px;
      padding-right: 18px;
    }

    &:nth-child(6n + 3) {
      padding-left: 18px;
      padding-right: 18px;
    }

    &:nth-child(6n + 4) {
      text-align: right;
      padding-left: 16px;
      padding-right: 25px;
    }

    &:nth-child(6n + 5) {
      padding-left: 22px;
      padding-right: 22px;
    }

    &:nth-child(6n + 6) {
    }
  `,
  PopUpContainer: styled.div`
    min-width: 181px;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
  `,
  List: styled.ul`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
  `,
  Item: styled.li`
    padding: 9px 7px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #666666;
    cursor: pointer;

    &:hover {
      background-color: ${rgba('#000000', 0.15)};
    }
  `,

  // Exam Result Detail
  Return: styled.div`
    background: #FFFFFF;
    margin-bottom: 25px;
  `,
  ReturnIcon: styled.img.attrs({ src: ReturnIcon })`
    cursor: pointer;
  `,
  TabNavigation: styled.div<{ isEmpty: boolean }>`
    display: flex;
    ${props => props.isEmpty ? `
    border-bottom: 1px solid #7D7D7D;
    ` : `
    border-bottom: none;
    `}
    margin-top: 50px;
  `,
  TabLink: styled.p<{ isAcitve: boolean }>`
    padding: 5px 10px;
    border: 1px solid #7D7D7D;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    cursor: pointer;
    background: #fff;
    ${props => props.isAcitve ? `
      color: #2c2c2c;
      border-left: 5px solid orange;
      padding-left: 6px;
    ` : `
      color: #0e0e0e;
    `}
  `,
  FileAnswerContainer: styled.div`
    margin: 10px 2% 0;
  `,
  AnswerImg: styled.img`
    max-width: 200px;
    max-height: 200px;
  `,
  AnswerDownloadLink: styled.a`
    color: #005aff;
    text-decoration: underline;
    &:hover {
      color: blue;
    }
  `,
  AnswerFileIcon: styled.img.attrs({ src: examReviewFileIcon })`
    width: 22px;
    margin-right: 5px;
  `,
  ExamScoreWrap: styled.div`
  `,
  ExamTopicArea: styled.div`
    border-radius: 14px;
    padding: 39px 55px;
  `,
  ExamTopicTitle: styled.p`
    font-weight: 700;
    font-size: 36px;
    color: #5C5C5C;
    margin-bottom: 48px;
    border-bottom: 2px solid silver;
    padding-bottom: 5px;
  `,
  ExamTopic: styled.div`
    margin-bottom: 90px;
    font-weight: 700;
    color: #5C5C5C;
  `,
  ExamTopicNumber: styled.div`
    margin-right: 10px;
    background-color: #fff;
    border-radius: 0 20px 20px 0;
    position: absolute;
    left: -10px;
    padding: 0 10px 0 25px;
  `,
  ExamTopicContent: styled.div`
    margin-left: 24px;
  `,
  ExamTopicQuestion: styled.div`
    line-height: 40px;
    display: flex;
    background-color: #e6e6e6;
    border-radius: 15px;
    padding: 20px 55px 20px 20px;
    position: relative
  `,
  ExamTopicText: styled.div`
    margin-top: 5px;
    margin-left: 32px;
  `,
  CorrectAnswerList: styled.ul`
    list-style: disc;
  `,
  ChoosedAnswerList: styled.ul`
    color: #E98484;
    margin-top: 30px;
    list-style: disc;
  `,
  CorrectAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  ChoosedAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  Img: styled.img`
    display: flex;
    margin-top: 10px;
    &:hover {
      cursor: pointer;
    }
  `,
  AnswerTitle: styled.p`
    font-size: 18px;
    margin-bottom: 3px;
  `,
  ExamQAAnswerTitle: styled.p`
    font-size: 18px;
    margin: 20px 0 10px;
  `,
  ExamQAScore: styled.input.attrs({ type: 'number' })`
    margin: 0 2%;
    padding: 10px;
    border: 1px solid #707070;
    border-radius: 2px;
  `,
  ExamQAScoreTip: styled.span`
    font-size: 12px;
    vertical-align: bottom;
  `,
  ExamQAText: styled.textarea`
    width: 95%;
    margin: 0 2%;
    padding: 10px;
    resize: none;
    min-height: 100px;
  `,
  ExamCommentText: styled.textarea`
    width: 95%;
    margin: 0 2%;
    padding: 10px;
    resize: none;
    min-height: 50px;
  `,
  ExamMultiSelectText: styled.p`
    text-align: center;
    font-size: 22px;
    color: #666666;
    margin-top: 30px;
  `,
  QuestionsAllCorrect: styled.img.attrs({ src: QuestionsAllCorrectIcon })`
    display: block;
    margin: 0 auto;
  `,
  NoHandsOnHistoryContainer: styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
  `,
  HistoryTableCellLink: styled.a`
  `,
  ReviewHistoryTableWrapper: styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: minmax(91px,300px) auto auto auto auto auto auto;
    max-width: 1116px;
    align-items: center;
  `,
  ReviewHistoryName: styled.p`
    margin-right: 5px;
  `,
  ReviewHistoryTableCell: styled.div<{ isCenter?: boolean }>`
    font-size: 16px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #313131;
    ${props => props.isCenter ? `
      display: flex;
      justify-content: center;
      text-align: center;
    ` : null}

    &:nth-child(7n + 1) {
      padding: 14px 15px;
      display: flex;
    }

    &:nth-child(7n + 2) {
      padding-left: 15px;
      padding-right: 18px;
    }

    &:nth-child(7n + 3) {
      padding-left: 18px;
      padding-right: 18px;
    }

    &:nth-child(7n + 4) {
      text-align: right;
      padding-left: 16px;
      padding-right: 25px;
    }

    &:nth-child(7n + 5) {
      padding-left: 22px;
      padding-right: 22px;
    }

    &:nth-child(7n + 6) {
    }
  `,
  EditIcon: styled.img.attrs({ src: EditIcon })`
  `,
};

export const S = {
  ...otherS,
  TableHeading: styled.div<{ isCenter?: boolean }>`
    background-color: #EFEFEF;
    font-size: 16px;
    height: 58px;
    color: #313131;
    cursor: pointer;
    display: flex;
    align-items: center;
    ${props => props.isCenter ? `
      justify-content: center;
      text-align: center;
    ` : null}

    /* border: 1px solid black; */

    &:nth-child(2) ${otherS.TableHeadingText} {
      padding-left: 15px;
    }
  `,
  HistoryTableHeading: styled.div<{ isCenter?: boolean }>`
    background-color: #EFEFEF;
    font-size: 16px;
    height: 58px;
    color: #313131;
    cursor: pointer;
    display: flex;
    align-items: center;
    ${props => props.isCenter ? `
      justify-content: center;
      text-align: center;
    ` : null}

    &:nth-child(1) ${otherS.TableHeadingText} {
      padding-left: 15px;
    }
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: 10%;
    place-content: center;
  `,
  ErrorPage: styled(ErrorPage)`
    flex-grow: 1;
  `
}
